// this component is needed to test iframe integration
import Box from '@mui/material/Box';

const IframeScreen = () => (
  <Box sx={{ boxShadow: 5 }} style={{ marginTop: '100px' }}>
    <iframe title="pov test component" src="/" style={{ width: '100%', height: '282px', border: 0 }} />
  </Box>
);

export default IframeScreen;
